module.exports = __webpack_public_path__ + "media/images/onboarding-updates-ba089ca8.png";